module.exports = __webpack_public_path__ + "static/media/Aniedi.7ae4a200.jpeg";